import { h, Fragment, cn, type VNode } from '../../../lib/vdom.js';
import * as I from './Icon.js';

export default function Testimonials() {
  return (
    <section id="testimonials">
      <div className="content">
        <h3 className="section-subheading">TESTIMONIALS</h3>
        <h1 className="section-heading">What Do Our Clients Say?</h1>
        <div className="body">
          <div className="testimonial">
            <img src="/public/michael-ringkvist.jpeg" />
            <I.IconQuote />
            <div className="body">
              <p>
                I have had the pleasure of working with Sean for the past seven years and have consistently been
                impressed by his exceptional skills, depth of knowledge, and dedication to his craft.
              </p>
              <div className="footer">
                <p className="name">Michael Ringkvist</p>
                <p className="title">
                  CEO of Intecredo International Aps, chairman of the board of Danske Inkasso Aps, 2023
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
